// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ujpc","header":"ReportDetails_header__3NJpb","title":"ReportDetails_title__2ZPDQ","left":"ReportDetails_left__VcwoP"};